// src/LandingRedirect.jsx
import { Navigate } from "react-router-dom";
import { useAuth } from "./context/AuthContext";

export default function LandingRedirect() {
  const { usuario, loading } = useAuth();
  if (loading) return null;

  if (!usuario) return <Navigate to="/login" replace />;
  return usuario.rol === "ADMIN"
    ? <Navigate to="/admin/colegiados" replace />
    : <Navigate to="/dashboard" replace />;
}
